import PropTypes from 'prop-types';
import { filter, indexBy, path, prop } from 'ramda';
import React, { Component } from 'react';
import { readEndpoint } from 'redux-json-api';
import { LayerGroup } from 'react-leaflet';
import { connect } from 'react-redux';

import RouteBlockageFeature from './RouteBlockageFeature';
import { isAdmin } from '../modules/selectors/permissions';

class RouteBlockagesLayer extends Component {
  static propTypes = {
    readEndpoint: PropTypes.func.isRequired,
    routeBlockages: PropTypes.array.isRequired,
  };

  render() {
    const { routeBlockages, stops, isAdmin } = this.props;
    let children = [];

    if (routeBlockages.length > 0 && Object.keys(stops).length > 0) {
      routeBlockages.forEach(routeBlockage => {
        children.push((
          <RouteBlockageFeature
            key={'route-blockage-feature-' + routeBlockage.id}
            id={routeBlockage.id}
            stops={stops}
            routeBlockage={routeBlockage}
            isAdmin={isAdmin}
          />
        ));
      });
    }

    return (
      <LayerGroup key='route-blockages-layer'>
      {children}
      </LayerGroup>
    );
  };
}


const selectRouteBlockages = (state) => {
  const routeBlockages = path(['api', 'route-blockage', 'data'], state) || [];

  const isActive = routeBlockage => {
    const endedAt = path(['attributes', 'ended-at'], routeBlockage);

    return !endedAt;
  };

  return filter(isActive)(routeBlockages);
};

const selectRailways = (state) => {
  const railways = state.api.railway && state.api.railway.data || [];

  return indexBy(prop('id'), railways);
};

const selectStops = (state) => {
  const stops = state.api.stop && state.api.stop.data || [];

  return indexBy(prop('id'), stops);
};

const mapStateToProps = (state) => ({
  routeBlockages: selectRouteBlockages(state),
  railways: selectRailways(state),
  stops: selectStops(state),
  isAdmin: isAdmin(state),
});

const mapDispatchToProps = {
  readEndpoint,
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteBlockagesLayer);
